<template>
  <div  style="justify-content: flex-start !important">
    <div class="d-flex flex-wrap" :style="{ gap: interval ? interval + 'px' : '0' }" v-dragula="temp_imageArray" :service="componentId" :drake="componentId">
      <div class="d-flex flex-wrap" :style="`margin:0px ${interval??0}px ${interval??0}px 0px`" v-for="(image, index) in temp_imageArray" :key="image.imageId">
        <b-button v-b-toggle="'imageupload_' + componentId + image.imageId"
          :ref="'imageupload_' + componentId + image.imageId"
          variant="light"
          class="btn btn-light d-flex"
          :class="{'selected': !!image.imageSrc}"
          :style="`padding: 0px;writing-mode: vertical-lr;width:${ShowWidth??80}px;height:${ShowHeight??100}px`">
          <img class="img-fluid m-auto top-radius-blog" :src="image.imageSrc" alt="" />
          <slot name="ButtonIcon"></slot>
        </b-button>
        <b-sidebar sidebar-class="imgSidebar" :ref="'imageupload_sidebar_' + componentId + image.imageId"
          :id="'imageupload_' + componentId + image.imageId" title="" right bg-variant="white" backdrop :shadow="true"
          @hidden="sidebarHidden(image.imageId)" @change="toggleBodyScrollbar">
          <imageUploadDetail :imageId="image.imageId" :imageSrc="image.imageSrc" :UpdateImage="UpdateImage" :limitCropFunction="limitCropFunction"
            :aspectRatioselected="aspectRatioselected" :needImageName="needImageName" :FileName="image.FileName"
            :imageName="image.imageName" :DeleteImage="DeleteImage" :nextBtn="index + 1 < temp_imageArray.length || !reachLimit ? btnNext_Click : null
              " :prevBtn="index - 1 >= 0 ? btnPrev_Click : null"
            :ref="'newImageUploadDetail_' + componentId + image.imageId"
            :minCropBoxWidth="minCropBoxWidth"
            :minCropBoxHeight="minCropBoxHeight"
            :minCanvasWidth="GetMinCanvasWidth"
            :minCanvasHeight="GetMinCanvasHeight"
            :minContainerWidth="GetMinContainerWidth"
            :minContainerHeight="GetMinContainerHeight"
            :viewmode="viewmode"
            :autoCrop="autoCrop"
            :disabled="disable">
          </imageUploadDetail>
        </b-sidebar>
      </div>

      <b-button v-b-toggle="'imageupload_' + componentId + '0'" variant="light" :class="ReturnRequied ? 'ButtonStyle' : '' "
      :style="`padding: 10px;width:${ShowWidth??80}px;height:${ShowHeight??100}px`" :ref="'imageupload_' + componentId + '0'" v-if="!reachLimit"
        :disabled="disable">
        <i v-if="!IsHidenAddIcon" class="icofont icofont-ui-add font-dark"></i>
        <slot name="AddText"></slot>
        <slot name="ButtonIcon"></slot>
      </b-button>
    </div>

    <b-sidebar sidebar-class="imgSidebar" :ref="'imageupload_sidebar_' + componentId + '0'" @hidden="sidebarHidden(0)"
      :id="'imageupload_' + componentId + '0'" title="" right bg-variant="white" backdrop :shadow="true"
      @change="toggleBodyScrollbar" :visible="showNewSidebar">
      <imageUploadDetail :imageId="0" :UpdateImage="UpdateImage" imageName="" :DeleteImage="DeleteImage" :limitCropFunction="limitCropFunction"
        :aspectRatioselected="aspectRatioselected" :needImageName="needImageName"
        :ref="'newImageUploadDetail_' + componentId + 0" :prevBtn="temp_imageArray.length > 0 ? btnPrev_Click : null" :disabled="disable">
      </imageUploadDetail>
    </b-sidebar>
    <div v-if="ReturnRequied" style="color: red;padding-left: 6px;padding-top: 2px;">{{$t("lbl_EMPBE_Please_Upload_Photo")}}</div>
  </div>
</template>
<script>
import imageUploadDetail from "./imageUploadDetail.vue";
import { fileUploadService } from "../../../_services";
export default {
  props: [
    "componentId",
    "limit",
    "imageWidth",
    "imageHeight",
    "disable",
    "aspectRatioselected",
    "needImageName",
    "imageArray",
    "limitCropFunction",
    "IsRequired",
    "minCropWidth",
    "minCropHeight",
    "minCanvasWidth",
    "minCanvasHeight",
    "minContainerWidth",
    "minContainerHeight",
    "viewmodeselected",
    "autoCrop",
    "ShowHeight",
    "ShowWidth",
    'IsHidenAddIcon',
    "interval"
  ],
  components: {
    imageUploadDetail,
  },
  data() {
    return {
      temp_imageArray: this.imageArray != null ? this.imageArray : [], // imageId, imageName, imageSrc, modified, cdnLnk
      mylimit: this.limit ? this.limit : 1,
      reachLimit: false,
      showNewSidebar: false,
      IsRequiredStyle:false,
      IsCreated:true,
      minCropBoxWidth: this.minCropWidth ?? 0,
      minCropBoxHeight: this.minCropHeight ?? 0,
      viewmode: this.viewmodeselected ?? 0
    };
  },
  computed: {
    ReturnRequied(){
        return this.IsRequiredStyle && this.IsRequired && (this.temp_imageArray.length<1);
    },
    GetMinCanvasWidth(){
      return this.minCanvasWidth ?? 0;
    },
    GetMinCanvasHeight(){
      return this.minCanvasWidth ?? 0;
    },
    GetMinContainerHeight(){
      return this.minContainerHeight ?? 2100
    },
    GetMinContainerWidth(){
      return this.minContainerWidth ?? 200
    },
    IsAutoCrop(){
      return this.autoCrop ?? true
    }
  },
  watch: {
    imageArray() {
      this.temp_imageArray = this.imageArray != null ? this.imageArray : [];
      this.reachLimit = this.mylimit <= this.temp_imageArray.length;
    },
    limit() {
      this.mylimit = this.limit ? this.limit : 1;
      this.reachLimit = this.mylimit <= this.temp_imageArray.length;
    },
    temp_imageArray() {
      this.reachLimit = this.mylimit <= this.temp_imageArray.length;
    },
    reachLimit()
    {
      if(this.IsRequired && !this.IsCreated)
      {
          this.IsRequiredStyle=!this.reachLimit;
      }
    }
  },
  mounted() {
    this.reachLimit = this.mylimit <= this.temp_imageArray.length;
    this.IsCreated=false;
  },
  beforeDestroy() {
    const body = document.getElementsByTagName("body")[0];
    body.classList.remove("overflow-hidden");
  },
  methods: {
    toggleBodyScrollbar(visible) {
      const body = document.getElementsByTagName("body")[0];

      if (visible) body.classList.add("overflow-hidden");
      else body.classList.remove("overflow-hidden");
    },
    UpdateImage(imageId, imageSrc, imageName, FileName) {
      if (imageSrc != "" && imageSrc != undefined) {
        if (imageId < 1) {
          var newImageId = this.temp_imageArray.length + 1;
          this.temp_imageArray.push({
            imageId: newImageId,
            imageSrc: imageSrc,
            modified: true,
            imageName: imageName,
            cdnLnk: "",
            FileName: FileName,
          });
        } else {
          this.temp_imageArray.find((image) => {
            if (image.imageId === imageId) {
              //Check if modified
              if (
                image.imageSrc != imageSrc ||
                image.imageName != imageName ||
                image.FileName != FileName
              ) {
                image.imageSrc = imageSrc;
                image.modified = true;
                image.imageName = imageName;
                image.cdnLnk = "";
                image.FileName = FileName;
              }
            }
          });
        }
      }
      if (imageId == 0) {
        this.$refs["imageupload_" + this.componentId + imageId].click();
      } else {
        this.$refs["imageupload_" + this.componentId + imageId][0].click();
      }
      this.reachLimit = this.mylimit <= this.temp_imageArray.length;
    },
    DeleteImage(imageId) {
      let i = this.temp_imageArray.map((image) => image.imageId).indexOf(imageId); // find index of your object
      this.$refs["imageupload_sidebar_" + this.componentId + imageId][0].hide();
      setTimeout(() => {
        this.temp_imageArray.splice(i, 1); // remove it from array
        this.reachLimit = this.mylimit <= this.temp_imageArray.length;
      }, 300);
    },
    AppendUploadQuery() {
      if (this.temp_imageArray.length > 0) {
        fileUploadService.AppendQuery(this.componentId, "Image", this.temp_imageArray);
      }
    },
    btnNext_Click(imageId) {
      let i = this.temp_imageArray.map((image) => image.imageId).indexOf(imageId); // find index of your object
      this.$refs["imageupload_sidebar_" + this.componentId + imageId][0].hide();
      if (i + 1 < this.temp_imageArray.length) {
        var next = this.temp_imageArray[i + 1];
        this.$root.$emit(
          "bv::toggle::collapse",
          this.$refs["imageupload_sidebar_" + this.componentId + next.imageId][0].id
        );
      } else if (!this.reachLimit) {
        this.$root.$emit(
          "bv::toggle::collapse",
          this.$refs["imageupload_sidebar_" + this.componentId + "0"].id
        );
      }
    },
    btnPrev_Click(imageId) {
      if (imageId == 0) {
        this.$refs["imageupload_sidebar_" + this.componentId + "0"].hide();
        var next = this.temp_imageArray[this.temp_imageArray.length - 1];
        this.$root.$emit(
          "bv::toggle::collapse",
          this.$refs["imageupload_sidebar_" + this.componentId + next.imageId][0].id
        );
      } else {
        let i = this.temp_imageArray.map((image) => image.imageId).indexOf(imageId); // find index of your object
        this.$refs["imageupload_sidebar_" + this.componentId + imageId][0].hide();
        if (i - 1 >= 0) {
          var next = this.temp_imageArray[i - 1];
          this.$root.$emit(
            "bv::toggle::collapse",
            this.$refs["imageupload_sidebar_" + this.componentId + next.imageId][0].id
          );
        }
      }
    },
    sidebarHidden(imageId) {
      if (imageId > 0) {
        // this.$refs["newImageUploadDetail_" + this.componentId + imageId][0].confirm();
        // this.$refs["imageupload_sidebar_" + this.componentId + imageId][0].hide();
      } else {
        // this.$refs["newImageUploadDetail_" + this.componentId + imageId].confirm();
        this.$refs["newImageUploadDetail_" + this.componentId + imageId].remove();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.btn.btn-light {
  &.selected {
    background-color: white !important;
  }

  &.disabled:hover {
    background-color: #f8f9fa !important;
    border-color: #f8f9fa !important;
  }
}
</style>
<style scoped>
.ButtonStyle
{
  border: 1px solid red !important;
}
</style>